export enum TransactionStatus {
    Pending = 'pending',
    Done = 'done',
    Error = 'error',
}

export enum DateAggregation {
    Day = 'day',
    Month = 'month',
    Year = 'year'
}

export enum TransactionType {
    InvoicePayment = 'invoicePayment',
    InvoiceRefund = 'invoiceRefund',
    OperatorPayout = 'operatorPayout',
    OperatorPayment = 'operatorPayment',
    AgencyPayout = 'agencyPayout',
    OperatorRefund = 'operatorRefund',
}

export enum RefundTransactionType {
    InvoiceRefund = TransactionType.InvoiceRefund,
    OperatorRefund = TransactionType.OperatorRefund,
}
export enum TransactionOccurrence {
    First = 'first',
    Rebill = 'rebill',
    Any = 'any'
}

export enum TimePackageType {
    Gift = 'gift',
    GiftVerification = 'gift_verification',
    GiftAdmin = 'gift_admin',
    Credit = 'credit',
    Purchasable = 'purchasable',
    Promo = 'promo',
    Welcome = 'welcome',
    GiftAfterSignup = 'gift_after_signup',
}

export enum OperatorPaymentReason {
    Room = 'room',
    Gift = 'gift',
    Bonus = 'bonus',
    Admin = 'admin',
    OperatorReferral = 'operatorReferral',
    UserReferral = 'userReferral',
    ContestReward = 'contestReward',
    ModelPenalty = 'modelPenalty',
}

export enum TimeTransactionReason {
    Room = 'room',
    Gift = 'gift',
    Expired = 'expired',
    Admin = 'admin',
    Refund = 'refund',
    Purchase = 'purchase',
    WelcomeBonus = 'welcomeBonus',
}

export enum TimeTransactionGroup {
    Room = 'room',
    Operator = 'operator',
}

export enum OfferType {
    Subscription = 'subscription',
    TimePackage = 'timePackage',
    TrialSubscription = 'trialSubscription',
}

export enum ContestGiftType {
    Default = 'default',
    Bonus = 'bonus',
}
